module.exports = __webpack_public_path__ + "static/ConsultantAihara-615cb95160947b7e0561f14bae6bf8df.jpg";